var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Modal, useModal } from '../modal';
import { headerStyle } from './styles';
function Header(_a) {
    var { children, mode = 'plain' } = _a, restProps = __rest(_a, ["children", "mode"]);
    const { alignCenter } = useModal();
    return (_jsx(Modal.Header, Object.assign({ css: headerStyle({ alignCenter, mode }), mode: mode }, restProps, { children: children })));
}
export default Header;
